// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Tk7G","topBottomGutter":"Layout_topBottomGutter__2YUuW"};